module.exports = ".reservation-report-area-container{padding:16px}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/merchant-tools/reservation-report/reservation-report.component.scss
// module id = 1267
// module chunks = 0